module.exports = __webpack_public_path__ + "static/water_nubian3-122cf7f0267a96a33d4cc5a0991c1988.jpg";